<template>
    <div>
        <form action="?" method="POST">
            <div id="html_element"></div>
            <br />
            </form>
    </div>
</template>

<script>
export default {
    name: 'AigosmartHomeRecaptcha',

    data() {
        return {
            
        };
    },

    mounted() {
        window.verifyCallback = this.verifyCallback;
        window.onloadCallback = this.onloadCallback;
        this.onloadCallback()
    },

    methods: {
     verifyCallback (response) {
        console.log(response);

        this.$emit("captchaToken", response)
      },

       onloadCallback  () {
        grecaptcha.render("html_element", {
          sitekey: "6LfNLtsiAAAAAKWuCNANAKu5UAjhrw8M4VEicDXx",
          callback: verifyCallback,
        });
      },
    },
};
</script>

<style lang="scss" scoped>

</style>